import { STATUS } from '@front-app/constants/state';
import { HtmlString } from '@front-app/services/SharedModels';
import { FullUser, UserDetailRole, UserSalutation } from '@front-app/services/UserApi/UserModel';
import { Ref, ref } from '@vue/composition-api';
import { InnerUserStore } from './model';

export const getFullUserStore = (): InnerUserStore<FullUser> => {
	const state: Record<string, Ref<FullUser>> = {};
	const set = (user: FullUser): void => {
		if (state[user.id]) {
			state[user.id].value = Object.assign(state[user.id].value, user);
		} else {
			state[user.id] = ref(user);
		}
	};
	const get = (id: string): Ref<FullUser> => {
		const item = state[id];
		if (!item) {
			state[id] = ref(getFullUserWithStatusAndId(id, STATUS.UNSTARTED));
		}
		return state[id];
	};
	const has = (id: string): boolean => Boolean(state[id]);
	return {
		set,
		get,
		has,
	};
};

export function getFullUserWithStatusAndId(id: string, status: STATUS): FullUser {
	return {
		id,
		status,
		primaryRole: UserDetailRole.NONE,
		roles: [],
		displayName: '',
		salutation: UserSalutation.NONE,
		firstName: '',
		middleName: '',
		lastName: '',
		email: '',
		authenticated: false,
		verified: false,
		credentials: [],
		specialties: [],
		interests: [],
		summaryForAll: '' as HtmlString,
		summaryForContacts: '' as HtmlString,
		phone: '',
		mobile: '',
		gender: null,
		languages: [],
		birthdayYear: '',
		birthdayMonth: '',
		birthdayDay: '',
		professionalExperiences: [],
		associations: [],
		currentOccupation: {
			id: -1,
			positionTitle: '',
			phone: '',
			startMonth: null,
			startYear: null,
			endMonth: null,
			endYear: null,
			location: {
				street1: '',
				street2: '',
				city: '',
				provStateRegion: null,
				country: null,
				postalCode: '',
				contactInfo: {
					phone: '',
					extension: '',
					mobile: '',
					fax: '',
					webaddress: '',
				},
			},
			employer: {
				id: 0,
				name: '',
				type: '',
				logoSrc: '',
				address: {
					street1: '',
					street2: '',
					city: '',
					provStateRegion: null,
					country: null,
					postalCode: '',
					contactInfo: {
						phone: '',
						extension: '',
						mobile: '',
						fax: '',
						webaddress: '',
					},
				},
			},
		},
	};
}
